<div class="u-shadow-mini pos-relative">
    <app-loader [showLoader]=showLoad></app-loader>

    <div class="c-portlet_box_specs">
        <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap">
            <div class="o-stack__cell">
                <h5> {{sectiontitle}}</h5>
            </div>
        </div>
        <div class="analytics-portlet-content pos-relative" style="height: 400px">
            <div class="o-stack o-stack--nowrap o-stack--center">
                <app-donut [chartData]="seriesData" [chartConfigurationObj]="{'seriesName': 'groupBy'}"></app-donut>
            </div>
        </div>
    </div>
</div>
